import React from 'react'
import { TextField } from 'react-admin'
import pretty from 'prettysize'
import _ from 'lodash'

export default props => {
  props.record[props.source] = pretty(_.get(props.record, props.source))
  return <TextField {...props} />
}
